module.exports = __webpack_public_path__ + "static/TangleTower5-ae5acd4af424c14ca2bdb941065ddda7.png";